import { Typography } from "@mui/material"

 export const PageNotFound = () =>{
    return(

        <Typography variant="h1">Page Not Found</Typography>
    )
 }